/**
 * Native labels for supported locales.
 *
 * Each label is written in its own language so the selector stays readable
 * even before the interface language changes.
 */
export const localeLabels = {
  en: 'English',
  fr: 'Français',
  pl: 'Polski',
};
